import Modal from 'react-modal';

export default function ModalFeaturesOpen({ modalFeaturesOpen, listFeatures, customStylesFeatures, setModalLogFeaturesOpen }) {
    return (
        <Modal
            isOpen={modalFeaturesOpen}
            style={customStylesFeatures}
            onRequestClose={() => setModalLogFeaturesOpen(false)}
            contentLabel="Características"
            ariaHideApp={false}
            keepMounted
        >
            <div className="body-modal">
                <div className="formDiv">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Característica</th>
                                <th>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listFeatures && listFeatures?.length > 0 && listFeatures.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            {index + 1}
                                        </td>
                                        <td>{item.descricao}</td>
                                        <td>{item.valor}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </Modal>
    )
}